import { postApi } from "@/utils/http";

export default function(Vue) {
  return {
    postApi: postApi,

    async clearForm(form, newVal) {
      for (const input of form.inputs) {
        input.value = newVal;
      }
    },

    notify(title, text, type, duration, speed) {
      Vue.notify({
        group: "all",
        title: title || "",
        text: text || "",
        duration: duration || 4000,
        speed: speed || 200,
        type: type || "success"
      });
    },

    wait(s) {
      return new Promise(resolve => {
        setTimeout(() => {
          resolve();
        }, s * 1000);
      });
    },

    getProp(obj, propStr) {
      if (obj && propStr) {
        const arr = propStr.split(".");
        while (arr.length && (obj = obj[arr.shift()]));
        return obj;
      }

      return null;
    },

    filter(items, filter) {
      items = items.filter(item => {
        return this.doesObjMatch(item, filter);
      });

      return items;
    },

    checkFilter(item, filter, prop) {
      if (filter[prop][0] == "!") {
        return this.checkNotStrFilter(item, filter, prop);
      } else {
        return item[prop] === filter[prop] ? true : false;
      }
    },
    checkNotStrFilter(item, filter, prop) {
      filter[prop] = filter[prop].replace("!", "");
      return item[prop] !== filter[prop] ? true : false;
    },

    doesObjMatch(item, filter) {
      item = Object.assign({}, item);

      for (const prop in filter) {
        if (!item[prop] && !filter[prop]) {
          return true;
        } else if (!item[prop] && filter[prop]) {
          return false;
        }

        //console.log(item[prop]);

        if (
          typeof item[prop] !== "string" &&
          Object.getOwnPropertyNames(item[prop]).length != 0
        ) {
          return this.doesObjMatch(item[prop], filter[prop]);
        } else {
          // console.log(filter[prop]);
          // console.log(item[prop]);

          if (typeof item[prop] === "string") {
            item[prop] = item[prop].toLowerCase();
          }

          if (typeof filter[prop] === "string") {
            filter[prop] = filter[prop].toLowerCase();
          }

          if (typeof filter[prop] === "string" && filter[prop].includes("|")) {
            if (filter[prop].split("|").indexOf(item[prop]) !== -1) {
              return true;
            }

            return false;
          } else {
            return this.checkFilter(item, filter, prop);
          }
        }
      }
    }
  };
}
